import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advertiser-terms',
  templateUrl: './advertiser-terms.component.html',
  styleUrls: ['./advertiser-terms.component.scss']
})
export class AdvertiserTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
